import { DeviceParameterConfig } from '@eppendorf/app-configs';
import {
  DeviceDTO,
  TelemetryHistoryEnrichedDTO,
} from '@eppendorf/vnls-device-service-utils';

import { useDeviceTypeConfig } from '$components/app-config/useDeviceTypeConfig';

export function useDeviceParameterAccessor(
  device?: DeviceDTO,
): (telem?: TelemetryHistoryEnrichedDTO) => DeviceParameterConfig | undefined {
  const config = useDeviceTypeConfig(device as Parameters<typeof useDeviceTypeConfig>[0]);

  return (telem?: TelemetryHistoryEnrichedDTO) =>
    config?.parameters?.find(
      ({ subject, name }) => subject === telem?.telemetryId || name === telem?.name,
    );
}
